// https://www.me.uk/cards/makeadeck.cgi
// todo: SVG sprite map

import { CardRank, CardSuit } from "../game/card";

export type PlayingCardProps = {
    rank: CardRank;
    suit: CardSuit;
    hidden?: boolean;
    top: string;
    left: string;
    height: string;
    onClick: (rank: CardRank, suit: CardSuit) => void;
};

export function PlayingCard({rank, suit, hidden, height, top, left, onClick}: PlayingCardProps) {
    return (
        <img id={rank + suit[0]} src={getImagePath(rank, suit)} hidden={hidden}
            alt={rank + " of " + suit}
            className='playing-card'
            style={{height, top, left}}
            onClick={() => onClick(rank, suit)}
        />
    );
}

export function getImagePath(rank: CardRank, suit: CardSuit): string {
    return "./images/" + rank + suit[0] + ".svg";
}
